'use strict';

function uniqueTokens(tokens) {
    const seen = new Set();
    return (Array.isArray(tokens) ? tokens : [])
        .map((token) => String(token || '').trim())
        .filter((token) => token !== '' && !seen.has(token) && seen.add(token));
}

function movePhotoToken(order, sourceToken, targetToken, after = false) {
    const normalized = uniqueTokens(order);
    const sourceIndex = normalized.indexOf(sourceToken);
    const targetIndex = normalized.indexOf(targetToken);
    if (sourceIndex < 0 || targetIndex < 0 || sourceToken === targetToken) {
        return normalized;
    }

    normalized.splice(sourceIndex, 1);
    const targetAfterRemoval = normalized.indexOf(targetToken);
    normalized.splice(targetAfterRemoval + (after ? 1 : 0), 0, sourceToken);
    return normalized;
}

function movePhotoByOffset(order, token, offset) {
    const normalized = uniqueTokens(order);
    const index = normalized.indexOf(token);
    const target = index + Number(offset || 0);
    if (index < 0 || target < 0 || target >= normalized.length || target === index) {
        return normalized;
    }
    const temporary = normalized[target];
    normalized[target] = normalized[index];
    normalized[index] = temporary;
    return normalized;
}

module.exports = {
    movePhotoByOffset,
    movePhotoToken,
    uniqueTokens,
};
